import { render } from "./ModelPreview.vue?vue&type=template&id=9263e93a&scoped=true"
import script from "./ModelPreview.vue?vue&type=script&lang=js"
export * from "./ModelPreview.vue?vue&type=script&lang=js"

import "./ModelPreview.vue?vue&type=style&index=0&id=9263e93a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9263e93a"]])

export default __exports__